import ReactMarkdown from 'react-markdown';

import { PageTitles } from '@revelio/core';

import { ContentWrapper } from '../../../shared/ui/content-wrapper/content-wrapper';
import DashboardPage from '../../DashboardPage';
import { TrailPageConent } from './components/trial-page-content';
import trialPageContent from './markdown/data-enrichment-content.md';

export const DataEnrichmentTrialPage = () => {
  const title = [PageTitles.DATA_ENRICHMENT];

  return (
    <DashboardPage title={title} loading={false} scrollY={true}>
      <TrailPageConent>
        <ContentWrapper>
          <ReactMarkdown>{trialPageContent}</ReactMarkdown>
        </ContentWrapper>
      </TrailPageConent>
    </DashboardPage>
  );
};
